const ja = {
  agree: '同意する',
  required: '必須',
  optional: '任意',
  minutes: '分間',
  within_today: '本日中',
  see_more: '詳しく見る',
  cannot_be_used_at_the_moment: '現在ご利用になれません。',
  the_page_may_be_temporarily_unavailable_or_the_link_might_have_been_removed:
    '一時的にアクセスできない状況にあるか、リンクが削除された可能性があります。\n画面の更新、または一定時間経過後に改めてお試しください。\nご迷惑をおかけしておりますことをお詫び申し上げます。',
  error: {
    maximum_number_of_characters_exceeded: '文字数を超えています',
    less_than_required_character_length: '文字数が不足しています',
    contains_characters_that_cannot_be_used: '使用できない文字が含まれています',
    there_is_an_unanswered_question: '回答していない必須項目があります',
    an_item_was_not_filled_in_correctly: '正しく入力されていない項目があります',
    our_server_is_very_busy_at_the_moment_please_come_back_after_a_while:
      'ただいまサーバが大変混み合っております。しばらく経ってから再度アクセスしてください',
    server_is_unstable: 'サーバのデータの状態が不安定です',
  },
  btn: {
    refresh: '再読み込み',
  },
  please_wait_a_while_and_then_reload_the_app:
    'しばらくたってから再度アクセスして下さい',
  preview_mode_cannot_submit_response:
    '※プレビューモードの場合、回答の送信はできません',

  warning_get_coupon_message: {
    message: 'まだクーポンは発行されていません。\n注意事項をご確認ください。',
  },
};

export default ja;
